<template>
  <v-tabs class="sub-menu" slider-color="primary" height="64" style="margin-bottom: 15px;" background-color="transparent">
    <v-tab class="sub-menu-item" to="/substitutes" exact>
      <v-icon class="sub-menu-item-icon">fa-address-book</v-icon>
      {{ $t("delegationSubstitutesMenu.proxyUsersList") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/substitutes/deputyAuth">
      <v-icon class="sub-menu-item-icon">fa-address-card</v-icon>
      {{ $t("delegationSubstitutesMenu.deputyAuth") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "DelegationSubstitutesMenu",
  mounted() {
    this.$store.dispatch("Visual/setMenuBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  },
  computed: {}
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>

<style>
.sub-menu .v-tabs__bar {
  background-color: inherit;
}
</style>
